import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AppConstants } from '../app.constants';
import { UserService } from '../services/user.service';
import { LoginService } from '../services/login.service';
import { environment } from '../../environments/environment';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { ROLE_DEFAULT_PERMISSIONS } from '../shared/auth/permission.service';

@Component({
	selector: 'app-signup',
	templateUrl: './signup.component.html',
	styleUrl: './signup.component.css'
})

export class SignupComponent implements OnInit {

	userObj: any = {};
	emailPattern: any = AppConstants.emailPattern;
	form: FormGroup;

	isSaving: boolean = false;

	constructor(
		private router: Router,
		private userService: UserService,
		private loginService: LoginService,
		private toastr: ToastrService,
		private fb: FormBuilder
	) {
		this.form = this.fb.group({
			// username: ['', {
			// 	validators: [Validators.required, Validators.minLength(4), Validators.pattern(/^\w+$/)],
			// 	updateOn: 'blur'
			// }],
			email: ['', {
				validators: [Validators.required, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)],
				updateOn: 'blur'
			}],
			first_name: ['', [Validators.required, Validators.pattern(/^[A-Za-z]+$/)]],
			last_name: ['', [Validators.required, Validators.pattern(/^[A-Za-z]+$/)]],
			password: ['', {
				validators: [Validators.required, Validators.minLength(8), Validators.pattern(/^\S+$/)],
				// updateOn: 'blur'
			}],
			password_confirmation: ['', {validators: [Validators.required]}]
		  }, { validators: this.passwordsMatch.bind(this) });
	}

	ngOnInit(): void {
	}

	onSubmit() {
		if (this.form.valid) {
			this.userObj = { ...this.form.value };
			this.userObj.username = this.userObj.email;
			this.userObj.roles = ['DEVELOPER'];
			this.userObj.permissions = ROLE_DEFAULT_PERMISSIONS['DEVELOPER'];
			this.userService.create(this.userObj, null).subscribe(res => {
				if (res && res.status === true) {
					this.isSaving = false;
					this.loginService.login({
						username: this.userObj.username,
						password: this.userObj.password,
						grant_type: environment.grantType,
						client_id: environment.keycloakClientId,
						client_secret: environment.keycloakClientSecret,
						realm: environment.keycloakRealm,
						scope: environment.scope
					}).then(() => {
						if (this.router.url === '/signup') {
							this.router.navigate(['/home']);
							this.toastr.success('Login success', 'Welcome ' + this.userObj.username);
						}
					}).catch((err) => {});
				} else {
					this.toastr.error(res.message, 'Failed');
				}
			}, error => {
				this.isSaving = false;
			});
		}
	}

	// Check if a field is invalid and touched
	isInvalid(controlName: string): boolean {
		// const control = this.form.controls[controlName];
		// return control.touched && control.invalid;
		const control = this.form.get(controlName);
		if (!control) return false;

		// Special case for confirmPassword: Check group-level errors
		if (controlName === 'password_confirmation' && this.form.hasError('mustMatch')) {
			return true;
		}

		return control.touched && control.invalid;
	}

	// Check for specific validation error
	hasError(controlName: string, errorType: string): boolean {
		// return this.form.controls[controlName].hasError(errorType);
		const control = this.form.get(controlName);
		if (!control) return false;

		// Check for form-level 'mustMatch' error
		if (controlName === 'password_confirmation' && errorType === 'mustMatch') {
			return this.form.hasError('mustMatch');
		}

		return control.hasError(errorType);
	}

	// Custom validator to check if passwords match
	passwordsMatch(group: AbstractControl): ValidationErrors | null {
		const password = group.get('password')?.value;
		const confirmPassword = group.get('password_confirmation')?.value;
	  
		// Check if confirmPassword is invalid
		if (!confirmPassword) return null;
	  
		return password === confirmPassword ? null : { mustMatch: true };
	}	
}
